import axios from 'axios';

import config from '../../../config';

import { VoiceCallAgentConfiguration, VoiceCallAgentType } from '../interfaces';

const { apiServerUrl } = config;

export const getVoiceCallAgentIntegrations = (): Promise<
  VoiceCallAgentConfiguration[]
> => {
  return axios
    .get<VoiceCallAgentConfiguration[]>(
      `${apiServerUrl}/users/integrations/voice-call-agent`
    )
    .then(({ data }) => data);
};

export const getVoiceCallAgentConfigs = <T = unknown>(
  type: VoiceCallAgentType
) => {
  return axios
    .get<T>(
      `${apiServerUrl}/users/integrations/voice-call-agent/${type}/configs`
    )
    .then(({ data }) => data)
    .catch((error) => {
      if (error.response.status === 404) {
        return null;
      }
      throw error;
    });
};

export const updateVoiceCallAgentConfigs = <T = unknown>(
  configType: VoiceCallAgentType,
  config: T
) => {
  return axios
    .post<T>(
      `${apiServerUrl}/users/integrations/voice-call-agent/${configType}/configs`,
      {
        configType,
        config,
      }
    )
    .then(({ data }) => data);
};
